import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import Page from './../../components/Page';
import Passes from './Passes';
import Pass from './Pass';
import NewPass from './NewPass';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import { observer } from 'mobx-react-lite';

const PassesTab = ({ store }) => {
    useEffect(() => {
        return () => {
            //clean up
            store.selectPass(undefined);
        };
    }, [store]);

    return (
        <Page>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.PASSES_F}>
                <Passes store={store} />
            </Route>
            <Route exact path={Paths.PASS_F}>
                <Pass store={store} />
            </Route>
            <Route exact path={Paths.NEW_PASS_F}>
                <NewPass store={store} />
            </Route>
        </Page>
    );
};

export default observer(PassesTab);
